import { Member, MemberTable } from '@services/member/member/member.types';
import { cosemApi } from '@services/providers/cosem';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { ActiveFilter } from '@utils/filters';

const customerApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getCustomers: build.mutation<ApiPaginationResponse<MemberTable>, { limit?: number; page?: number; search?: string; orderBy?: string, filters?: ActiveFilter[] }>({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return { 
                    url: `/product/customers`, 
                    method: 'GET',
                    params: { limit, page, search: search ?? "", orderBy: orderBy ?? "", filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<MemberTable>) => response
        }),
        getCustomer: build.mutation<ApiResponse<Member>, { id: string|number }>({
            query: ({ id }) => {
                return { 
                    url: `/product/customers/${id}`, 
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<Member>) => response
        }),
    })
});

export const { 
    useGetCustomersMutation,
    useGetCustomerMutation,
} = customerApi;
